document.addEventListener('keydown', function (event) {
  if (event.key === 'Tab' || event.key.includes('Arrow')) {
    document.body.classList.add('keyboard-navigation');
  }
});

// Optional: Remove the class when mouse is used
document.addEventListener('mousedown', function () {
  document.body.classList.remove('keyboard-navigation');
});
